import { GameLobby } from "@/features/rooms/components/GameLobby.tsx";

export const VoxelLobby = (
  { user }: { user?: { id: string; name?: string; isAnonymous?: boolean } },
) => {
  return (
    <GameLobby
      title="VOXEL WORLD"
      description="Build and explore with friends in a procedurally generated world."
      wsUrl="/ws/voxel"
      createUrl="/api/voxel/rooms"
      joinUrlPrefix="/voxel"
      user={user}
      buttonText="Create New World"
      showReserved // Enable reserved rooms for voxel too!
    />
  );
};
